import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {mergeAndSortExcursionAndTacEntries} from "../../utils/cartUtils";
import CartExcursionEntryCheckout from "./CartExcursionEntryCheckout";
import CartElementTacCheckout from "./CartElementTacCheckout";
import { useLingui } from '@lingui/react/macro';
import { navigate } from '../../utils/navigationUtils';


function CartElementsCheckoutCombined(props) {
    const excursions = useSelector(state => state.cart.excursions);
    const tacEntries = useSelector(state => state.cart.tac);
    const cruiseStartDate = useSelector(state => state.cruises.cruiseStartDate);
    const {t} = useLingui();

    const combinedSortedEntries = mergeAndSortExcursionAndTacEntries(excursions, tacEntries, cruiseStartDate);
    
    useEffect(() => {
        if(combinedSortedEntries.length === 0) {
            navigate(t({id: "/itinerary"}));
        }
    },[combinedSortedEntries]);

    return (
        <div className="bg-primary-lightest-25 px-4 py-1">
            {combinedSortedEntries.map(entry =>
                entry.excursionId ?
                <CartExcursionEntryCheckout key={entry.excursionId} excursion={entry}/> :
                <CartElementTacCheckout key={entry.id} entry={entry}/>
            )}
        </div>
    );
}

export default CartElementsCheckoutCombined;